<div class="teacher-time-stop-dialog-footer">
  <div class="teacher-time-stop-dialog-footer__confirm">
    <brt-button [color]="'white'" [title]="'Ja, stoppen'" [size]="'x-large'" (click)="answerAccept()"></brt-button>
  </div>
  <div class="teacher-time-stop-dialog-footer__cancel">
    <brt-button [color]="'white'" [title]="'Nein, fortsetzen'" [size]="'x-large'" (click)="answerCancel()"></brt-button>
  </div>
</div>
